import React from "react";

function Steps(props) {
  const { page } = props;

  const renderLog = (step) => {
    page.set("body.log.current", {
      ...page.state.body.log.current,
      ...step,
    });
    page.set("body.steps.show", false);
    page.set("body.log.show", true);
  };

  const subProcessSelect = async (sub) => {
    page.set("body.processLog.current", sub);
    page.set("body.steps.show", false);
    page.set("body.processLog.show", true);
  };

  return (
    <div className="column">
      <h1>{page.state.body.log.current.productName}</h1>
      <h3>Steps</h3>
      <div>
        <button
          className="btn-default btn-factory item shadow"
          onClick={() => {
            page.set("body.steps.show", false);
            page.set("body.products.show", true);
          }}
        >
          🞀🞀 Products
        </button>

        {page.state.stores.process.steps.map((step, index) => {
          //TODO:: refactor the backend to deliever the subprocess within the step
          const sub = page.state.stores.subProcess.find(
            (subProcess) => subProcess._id === step.subProcessId
          );
          return step.type === "sub" ? (
            <button
              key={step._id}
              className="btn-default btn-factory btn-process item shadow card"
              onClick={() => {
                subProcessSelect(sub);
              }}
            >
              <div className="list">{`No.${index + 1}`}</div>
              <b>{sub.name}</b>
            </button>
          ) : (
            <button
              key={step._id}
              className="btn-default btn-factory item shadow card"
              onClick={() => {
                renderLog(step);
              }}
            >
              <div className="list">{`No.${index + 1}`}</div>
              <b>{step.name}</b>
            </button>
          );
        })}
      </div>
    </div>
  );
}
export default Steps;
